export function checkVisible(elem) {
  if (elem) {
    var rect = elem.getBoundingClientRect();
    let heightMargin = (rect.bottom - rect.top) * 0.1 + 100;
    return (
      rect.bottom - heightMargin >= 0 &&
      rect.right >= 0 &&
      rect.top + heightMargin <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}
